import ActiveLoadsView from './ActiveLoadsView';

export default ActiveLoadsView;
